import { ProfileImg } from "./ProfileIMG.jsx";

export function ProfileButton({user, className, goToProfile}){
    return (
        <button className={`app-button flex items-center gap-1.25 duration-150 ${className}`}
         onClick = {goToProfile}>
            
            {/* Show profile pic */}
            <ProfileImg svgString={user.userIMG} />
            {/* Show user's name */}
            <span>
                {user.username}
            </span>
        </button>
    )
}
